import { useSupabase } from '@/hooks/useSupabase';

import { useEmployeeDirectoryEntry } from '../hooks';

import { EmployeeBadges } from './EmployeeBadges';

/**
 * Resumen read-only "Mi rol en la empresa" usado en UserMenu / Profile page.
 * Lee del directorio (vista) — refleja áreas + cargos vigentes del usuario
 * logueado. No tiene UI de edición: el cargo lo asigna un admin desde /equipo.
 */
export function MyRoleSummary({
  compact = false,
}: {
  compact?: boolean;
}) {
  const { user } = useSupabase();
  const { data, isLoading } = useEmployeeDirectoryEntry(user?.id);

  if (!user) return null;

  if (isLoading) {
    return (
      <span className="text-fg-dim font-mono text-micro">
        cargando rol…
      </span>
    );
  }

  if (!data) {
    return (
      <span className="text-fg-dim text-micro">
        Sin perfil de empleado todavía
      </span>
    );
  }

  return (
    <div className={compact ? 'space-y-1.5' : 'space-y-2'}>
      <div className="text-fg-dim text-micro">
        Mi rol en la empresa
      </div>
      <EmployeeBadges assignments={data.assignments} />
    </div>
  );
}
